export default __webpack_public_path__ + "static/media/complete-icon.fbaa7c75.svg";